import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { AppState } from '../../store/app.reducers';
import { AuthState } from '../../store/reducers';
import { RouteLink } from './route-link';
import * as authActions from '../../store/actions/index';

const HEADER_COMPACT_MAX_WIDTH = '(max-width: 900px)';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  public faPowerOff = faPowerOff;
  public loading: boolean;
  public routing: RouteLink[];
  /** Cabecera en vista móvil: enlaces pasan al panel inferior. */
  public isCompactNav: boolean;
  public navSheetOpen: boolean;
  private layoutSubscription = new Subscription();

  constructor(
    private store: Store<AppState>,
    private breakpointObserver: BreakpointObserver
  ) {
    this.loading = false;
    this.routing = [];
    this.isCompactNav = false;
    this.navSheetOpen = false;
  }

  public ngOnInit(): void {
    this.refreshCompactNav();
    this.layoutSubscription.add(
      this.breakpointObserver.observe(HEADER_COMPACT_MAX_WIDTH).subscribe(() => {
        this.refreshCompactNav();
        if (!this.isCompactNav) {
          this.navSheetOpen = false;
        }
      })
    );

    this.store.select('auth')
      .subscribe((authData: AuthState) => {
        this.loading = authData.loading;
        this.routing = authData.routes;
      });
  }

  public ngOnDestroy(): void {
    this.layoutSubscription.unsubscribe();
  }

  private refreshCompactNav(): void {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
      this.isCompactNav = window.matchMedia('(max-width: 900px)').matches;
    } else {
      this.isCompactNav = this.breakpointObserver.isMatched(HEADER_COMPACT_MAX_WIDTH);
    }
  }

  public openNavSheet(): void {
    this.navSheetOpen = true;
  }

  public closeNavSheet(): void {
    this.navSheetOpen = false;
  }

  public logout(): void {
    this.store.dispatch(authActions.logOutAction());
  }
}
